import React from 'react'
import Container from './Container'
import { string, func } from 'prop-types'

class ExpressDeals extends React.Component {
  componentDidMount () {
    this.props.loaded()
  }

  render () {
    return (
      <Container
        headingText={this.props.headingText}
        subHeadingTextPt1={this.props.subHeadingTextPt1}
        subHeadingTextPt2={this.props.subHeadingTextPt2}
        buttonText={this.props.buttonText}
        linkTagAnalytics={this.props.linkTagAnalytics}
        linkTagAction={this.props.linkTagAction}
        linkTagLabel={this.props.linkTagLabel}
        image={this.props.image}
        imageWebP={this.props.imageWebP}
        clickAction={this.props.clickAction}
      />
    )
  }
}

ExpressDeals.propTypes = {
  headingText: string,
  subHeadingTextPt1: string,
  subHeadingTextPt2: string,
  buttonText: string,
  image: string,
  imageWebP: string,
  linkTagAnalytics: string,
  linkTagAction: string,
  linkTagLabel: string,
  clickAction: func,
  loaded: func
}

export default ExpressDeals
